import BaseObject from '../../../base/base_object';
import {TimeSpan} from "@sparkware/app-utils";
import Event, {SystemEventSubscription} from '../../../utils/event';
import {SYSTEM_EVENTS} from '../../../events/events';
import ServiceFactory from '../../service_factory';


interface GenericRealityCheckMessageHandlerParams {
    serviceFactory: ServiceFactory;
    handleRealityCheckMessageCallback: (TimeSpan) => void;
    realityCheckInterval: TimeSpan
}

export default class GenericRealityCheckMessageHandler extends BaseObject {
    static CLASS = 'GenericRealityCheckMessageHandler';

    private _initParams: GenericRealityCheckMessageHandlerParams;
    init(params: GenericRealityCheckMessageHandlerParams) {
        super.init(params);
        this._initParams = params;
        this._subscribe();
    }

    private SESSION_TIMER_UPDATE_SUBSCRIPTION: SystemEventSubscription = null;
    private OAUTH_STATE_CHANGE_SUBSCRIPTION: SystemEventSubscription = null;
    private _subscribe(): void {
        Event.once(SYSTEM_EVENTS.SESSION_TIMER_UPDATE, (data)=> {
            this._firstOnSessionTimerUpdate(data);
        }, this);
        this.SESSION_TIMER_UPDATE_SUBSCRIPTION = Event.on(SYSTEM_EVENTS.SESSION_TIMER_UPDATE, this._onSessionTimerUpdate.bind(this), this);
        this.OAUTH_STATE_CHANGE_SUBSCRIPTION = Event.on(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, this._onOAuthStateChange.bind(this), this);
    }

    private _unsubscribe(): void {
        if (this.SESSION_TIMER_UPDATE_SUBSCRIPTION) {
            this.SESSION_TIMER_UPDATE_SUBSCRIPTION.off();
        }

        if(this.OAUTH_STATE_CHANGE_SUBSCRIPTION) {
            this.OAUTH_STATE_CHANGE_SUBSCRIPTION.off();
        }
    }


    dispose() {
        this._unsubscribe();
    }


    private _onOAuthStateChange(): void {
        this._lastRealityCheckMessageIndexShown = 0;
    }

    private _lastRealityCheckMessageIndexShown = 0;

    /**
     * update the last reality check message index shown according to first server call. we need it to solve the
     * problem that interval reminder shown every refresh
     * @param eventData
     * @private
     */
    private _firstOnSessionTimerUpdate(eventData: {sessionTime: TimeSpan}): void {
        if(!this._initParams.serviceFactory.oAuth2Service().isAuthorized()) {
            return;
        }

        // Reduce 1 minute so if user refresh few seconds before shown he will not loss the interval reminder.
        this._lastRealityCheckMessageIndexShown = Math.floor((eventData.sessionTime.totalMilliseconds - TimeSpan.fromMinutes(1).totalMilliseconds) / this._initParams.realityCheckInterval.totalMilliseconds);

        if(this._lastRealityCheckMessageIndexShown < 0) {
            this._lastRealityCheckMessageIndexShown = 0;
        }
    }

    private _onSessionTimerUpdate(eventData: {sessionTime: TimeSpan}): void {
        if(!this._initParams.serviceFactory.oAuth2Service().isAuthorized()) {
            return;
        }

        let currentRealityCheckMessageIndexToBeShown = Math.floor(eventData.sessionTime.totalMilliseconds / this._initParams.realityCheckInterval.totalMilliseconds);

        if(this._lastRealityCheckMessageIndexShown !== currentRealityCheckMessageIndexToBeShown) {
            this._initParams.handleRealityCheckMessageCallback(eventData.sessionTime);
            this._lastRealityCheckMessageIndexShown = currentRealityCheckMessageIndexToBeShown;
        }
    }
}